import React from 'react';
import './ButtonSpinner.scss';
import {ReactComponent as Loader} from '../../assets/spinner/button_spinner.svg';
import {ReactComponent as LoaderBlack} from '../../assets/spinner/button_spinner_black.svg';

const ButtonSpinner = props => {
    return (
        props.black
            ? <LoaderBlack className='buttonSpinnerLoader' style={{width: props.size + 'px', height: props.size + 'px'}} />
            : <Loader className='buttonSpinnerLoader' style={{width: props.size + 'px', height: props.size + 'px'}} />
    )
}

export default ButtonSpinner;
